module.exports = __webpack_public_path__ + "img/16.c2847804.png";